{
  "longPressMessage": "לחצו לחיצה ארוכה כדי לפתוח תצוגה מקדימה"
}
